// Electricity content
import ElectricityHero from 'assets/images/psp/hero/electricity-hero.webp';
import SecurityIcon from 'assets/images/icons/psp/camera.svg';
import WorkplaceIcon from 'assets/images/icons/psp/renovating.svg';
import ElectricityIcon from 'assets/images/icons/psp/electricity.svg';
import BusinessIcon from 'assets/images/icons/psp/shop.svg';
import ClimateControlIcon from 'assets/images/icons/psp/CC.svg';
import { getUnitImageUrl } from '../../../utils/units';
import ElectricityFeatured1 from 'assets/images/psp/FeaturedImages/electricity-1.webp';
import ElectricityFeatured2 from 'assets/images/psp/FeaturedImages/self1.webp';
import ElectricityFeatured3 from 'assets/images/psp/FeaturedImages/self2.webp';
import ElectricityFeatured4 from 'assets/images/psp/FeaturedImages/electricity-4.webp';

const reviews = [
	{
		reviewTitle: 'I needed a storage unit with power',
		reviewRating: 5,
		reviewText:
			'I needed a storage unit with power inside my unit, they found me one great price right value. Thank you so much SpareFoot.',
		reviewerInitials: 'NM',
		reviewerName: 'Nichelle Marie',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/5ee657ae7dd7530828c0bb6f',
	},
	{
		reviewTitle: 'Convenient and easy',
		reviewRating: 5,
		reviewText:
			'SpareFoot got me a great deal and was extremely convenient and easy to use!',
		reviewerInitials: 'A',
		reviewerName: 'Ashley',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/685ebc497f1c4d5c38cbe2ad',
	},
	{
		reviewTitle: 'Great Service!',
		reviewRating: 5,
		reviewText:
			'I am so happy that I was able to reserve the perfect-sized unit (with an electrical outlet) in advance. Its proximity to the airport and 24-hour access was exactly what I needed!',
		reviewerInitials: 'CJ',
		reviewerName: 'Cheryl Jonagan',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/64053ea8c3490ae5dad386ac',
	},
	{
		reviewTitle: 'Top Search, Best Find!',
		reviewRating: 5,
		reviewText:
			'SpareFoot appeared in a search for a cheaper storage option. My current storage site just increased my rent for the third time in six months but with SpareFoot, I was able to quickly find a new facility, closer to home, with the same size unit for $200 less! The readily available information and ease of use made securing my unit a breeze—all my requests were immediately received by my new storage facility.',
		reviewerInitials: 'AB',
		reviewerName: 'Angela Beale',
		reviewDate: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/685e17aa215632957faec95c',
	},
];

const faqs = [
	{
		question: 'Are there outlets in storage units?',
		answer: "Most standard storage units don't include electrical outlets, but many SpareFoot partner facilities offer units with electrical access as a premium amenity you can find via our filtering option. These powered units typically feature standard 110V outlets and are ideal for equipment storage, small business operations, or items requiring climate control monitoring.",
	},
	{
		question: 'Are storage facilities with electrical outlets metered?',
		answer: "Yes, most facilities with electrical outlets use metered systems. You'll either pay a flat monthly electrical fee or pay based on actual usage. Some facilities include a base amount of electricity in the rental rate, with overages billed separately. Always confirm the billing structure before renting.",
	},
	{
		question: 'Can I use a storage unit as a hobby workshop?',
		answer: "Absolutely! Using a storage unit as a hobby workshop is a great way to expand your space and keep your home tidy, without sacrificing the things you love. We recommend looking into storage units with electricity so you can easily install lighting and plug in any tools or devices necessary to build your workshop.Always be sure to review your lease and abide by your storage facility's terms and conditions for working out of a storage unit.",
	},
	{
		question: 'Do storage units have lights inside?',
		answer: 'Standard units rarely have built-in lighting, but many facilities provide well-lit hallways and exterior lighting. Storage units with outlets often include interior lighting or allow you to install your own fixtures. Battery-powered LED lights are popular alternatives for non-electrical units.',
	},
	{
		question: 'Do climate controlled storage units have outlets?',
		answer: "Not automatically. Climate control and electrical access are separate amenities, though they're often bundled together. Many climate-controlled units do include outlets to power monitoring equipment, dehumidifiers, or fans, but this varies by facility. Use SpareFoot's filters to find units with both amenities when needed.",
	},
];

export const ElectricityContent = {
	type: 'Storage with Electricity',
	sections: [
		{
			title: 'RV Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'rv-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Storage With Electricity For You',
							description:
								"From small business owners needing a secure, powered workspace for equipment and inventory to hobbyists requiring electricity for workshop tools, the need for accessible power extends far beyond your home's four walls. SpareFoot connects you with storage facilities that offer [storage units with electricity](https://www.sparefoot.com/blog/storage-units-with-electricity-how-to-find-storage-with-power), among other coveted amenities, giving you the flexibility to create a powered workspace, maintain equipment, or simply ensure your belongings stay protected with proper ventilation and lighting. Power up your side hustle, creative projects, car battery maintainer, and more with SpareFoot's network of facilities that give you the ability to rent storage units with power. ",
							image: ElectricityHero,
							CTAText: 'Find Storage With Electricity',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			background: 'gray',
			noPaddingBottom: true,
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Storage With Electricity Facilities Near',
					},
				},
			],
		},
		{
			title: 'RV-Storage Size Comparison',
			modules: [
				{
					title: 'RV Storage Content',
					type: 'content',
					props: {
						title: 'The Benefits of Storage Units with Electricity',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Storage units with electricity, also referred to as powered storage units, are standard storage units with the added amenity of electricity and active outlets available in-unit for your convenience. \n\n' +
								'It might be a surprise finding out that storage units do have electricity, but there’s more to storage with power than meets the eye. Many storage units with power outlets provide a [climate-controlled environment to protect your belongings](https://www.sparefoot.com/climate-controlled-storage.html) from heat and humidity damage, while providing workspace flexibility and often, improved security.',
						],
					},
				},
			],
		},
		{
			title: 'RV-Storage Size Comparison',
			noPaddingBottom: true,
			noPaddingTop: true,
			modules: [
				{
					title: 'RV Storage Content',
					type: 'content',
					props: {
						title: 'Do I Need a Storage Unit with Power?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Storage space with electricity can offer a whole host of benefits for personal and business storage users. You may not need a storage unit with outlets or power to store a few boxes, but it certainly can help, especially if you’re looking to transform your storage unit from passive storage to fully functional. ',
						],
					},
				},
				{
					title: 'Vehicle Storage Units',
					type: 'unitList',
					id: 'vehicle storage unit cards',
					props: {
						slug: 'vehicle-storage-unit-cards',
						scrollFactor: 3,
						unitsData: [
							{
								image: ClimateControlIcon,
								content:
									'### Specialized Climate Control \n\n Run dehumidifiers, fans, or climate control systems to protect sensitive electronics, documents, and musical instruments from temperature and humidity damage.',
							},
							{
								image: WorkplaceIcon,
								content:
									'### Flexible Workspace \n\n Transform storage into a functional workshop or studio space where you can operate power tools, maintain equipment, or run a small business.',
							},
							{
								image: SecurityIcon,
								content:
									'### Enhanced Security \n\n Power lighting systems, security cameras, and electronic locks for safer, more convenient access to your belongings.',
							},
							{
								image: ElectricityIcon,
								content:
									'### Electricity Access \n\n Keep recreational vehicles plugged in, charge battery-powered equipment, and maintain machinery that requires periodic operation.',
							},
							{
								image: BusinessIcon,
								content:
									'### Business Storage \n\n Create an affordable alternative to commercial space for e-commerce fulfillment, equipment storage, or workspace needs.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Supercharge Your Storage Unit with Power',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'How to Supercharge Your Storage Unit with Power Outlets ',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Your storage unit with power outlets is a well of untapped potential. Sure, renting a storage unit with electricity will provide you with comfort, convenience, and functionality, but there’s more to it than that. Pairing your powered storage unit with other amenities like 24/7 access, climate control, and enhanced security, or even drive-up access, can turn your convenient storage hub into a cool, secure, accessible workshop, tech haven, or hobbyist car shop.',
							"SpareFoot's extensive network allows customers to filter and compare facilities offering these specific amenity combinations, ensuring they find the perfect match for their unique powered storage requirements while comparing prices and availability across multiple providers.",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						// title: "Supercharge Your Storage Unit with Power",
						headers: [
							{
								label: 'Storage Amenity Combination',
								key: 'Storage Amenity Combination',
							},
							{
								label: 'Optimal Unit Sizes',
								key: 'Optimal Unit Sizes',
							},
							{
								label: 'Key Benefits',
								key: 'Key Benefits',
							},
							{
								label: 'Ideal Use Cases',
								key: 'Ideal Use Cases',
							},
						],
						rows: [
							{
								'Storage Amenity Combination': {
									type: 'markdown',
									markdown:
										'**Electricity + Climate Control**',
								},
								'Optimal Unit Sizes':
									'5x5 (mini storage unit with electricity) to 10x15',
								'Key Benefits': {
									type: 'markdown',
									markdown:
										'[Optimal temperature/humidity protection](https://www.sparefoot.com/blog/do-you-need-climate-control-in-your-storage-unit) with powered monitoring and equipment operation',
								},
								'Ideal Use Cases':
									'Electronics storage, wine collections, musical instruments, and art preservation',
							},
							{
								'Storage Amenity Combination': {
									type: 'markdown',
									markdown: '**Electricity + 24/7 Access**',
								},
								'Optimal Unit Sizes': '5x10 to 10x20',
								'Key Benefits':
									'Round-the-clock powered workspace availability for flexible scheduling',
								'Ideal Use Cases':
									'Small business operations, creative studios, equipment maintenance, and emergency access',
							},
							{
								'Storage Amenity Combination': {
									type: 'markdown',
									markdown:
										'**Electricity + Drive-Up Access**',
								},
								'Optimal Unit Sizes': '10x10 to 10x30',
								'Key Benefits':
									'Easy loading/unloading of powered equipment and heavy machinery',
								'Ideal Use Cases':
									'Workshop tools, RV charging, business inventory, and large electronics',
							},
							{
								'Storage Amenity Combination': {
									type: 'markdown',
									markdown:
										'**Electricity + First-Floor Access**',
								},
								'Optimal Unit Sizes': '5x5 to 10x15',
								'Key Benefits':
									'Convenient power access without stairs for heavy equipment and frequent use',
								'Ideal Use Cases':
									'Mobility equipment, business operations, and elderly/disabled accessibility',
							},
							{
								'Storage Amenity Combination': {
									type: 'markdown',
									markdown:
										'**Electricity + Security Features**',
								},
								'Optimal Unit Sizes': '5x5 to 10x20',
								'Key Benefits':
									'Enhanced protection with powered cameras, lighting, and alarm systems',
								'Ideal Use Cases':
									'High-value items, business inventory, sensitive documents, expensive equipment',
							},
							{
								'Storage Amenity Combination': {
									type: 'markdown',
									markdown:
										'**Electricity + Ground Level + Wide Doors**',
								},
								'Optimal Unit Sizes': '10x20 to 12x40',
								'Key Benefits':
									'Maximum convenience for vehicles, large equipment, and powered machinery',
								'Ideal Use Cases': {
									type: 'markdown',
									markdown:
										'[RV/boat storage](https://www.sparefoot.com/rv-storage.html) with charging, workshop space, and commercial equipment',
								},
							},
							{
								'Storage Amenity Combination': {
									type: 'markdown',
									markdown: '**All Amenities Combined**',
								},
								'Optimal Unit Sizes': '10x15 to 12x40',
								'Key Benefits':
									'Premium storage solution offering maximum flexibility, security, and convenience',
								'Ideal Use Cases':
									'High-end business operations, luxury item storage, professional workshops, and other specialized storage needs',
							},
						],
					},
				},
			],
		},
		{
			title: 'Storage Units with Electricity Prices',
			modules: [
				{
					type: 'sizeChart',
					props: {
						title: 'Average Storage with Electricity Prices',
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Standard Storage',
								key: 'Standard Storage',
							},
							{
								label: 'With Electricity Only',
								key: 'With Electricity Only',
							},
							{
								label: 'Electricity + Climate Control',
								key: 'Electricity + Climate Control',
							},
							{
								label: 'Electricity + Premium Amenities',
								key: 'Electricity + Premium Amenities',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'icon',
									icon: getUnitImageUrl(5, 5),
									heading: '5x5',
								},
								'Standard Storage': '$35-$60',
								'With Electricity Only': '$50-$80',
								'Electricity + Climate Control': '$70-$100',
								'Electricity + Premium Amenities': '$90-$120',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: getUnitImageUrl(5, 10),
									heading: '5x10',
								},
								'Standard Storage': '$50-$90',
								'With Electricity Only': '$70-$120',
								'Electricity + Climate Control': '$90-$140',
								'Electricity + Premium Amenities': '$110-$160',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: getUnitImageUrl(10, 10),
									heading: '10x10',
								},
								'Standard Storage': '$80-$150',
								'With Electricity Only': '$110-$180',
								'Electricity + Climate Control': '$125-$200',
								'Electricity + Premium Amenities': '$150-$240',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: getUnitImageUrl(10, 15),
									heading: '10x15',
								},
								'Standard Storage': '$120-$200',
								'With Electricity Only': '$150-$250',
								'Electricity + Climate Control': '$175-$275',
								'Electricity + Premium Amenities': '$200-$320',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: getUnitImageUrl(10, 20),
									heading: '10x20',
								},
								'Standard Storage': '$150-$250',
								'With Electricity Only': '$180-$300',
								'Electricity + Climate Control': '$220-$350',
								'Electricity + Premium Amenities': '$260-$400',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: getUnitImageUrl(10, 30),
									heading: '10x30',
								},
								'Standard Storage': '$200-$350',
								'With Electricity Only': '$250-$420',
								'Electricity + Climate Control': '$300-$500',
								'Electricity + Premium Amenities': '$350-$580',
							},
						],
					},
				},
			],
		},
		{
			title: 'Storage Units with Electricity content',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Understanding Storage Unit Amenity Costs',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						content: [
							'**Base Electricity Premium:** Storage units with electrical access typically cost 20-50% more than standard units, with the premium varying by location and facility quality. \n\n' +
								'**Regional Variations:** Prices vary significantly by market, with urban areas commanding 30-60% higher rates than rural locations. \n\n' +
								'**Additional Costs:**\n\n' +
								'- Security deposit: $25-$50\n\n' +
								'- Administrative fees: $10-$25\n\n' +
								'- Insurance (optional): $8-$15/month\n\n' +
								'**Facility Policies:** Some facilities may charge extra for specific amenities like climate control or security cameras. \n\n' +
								'*Premium amenities include: 24/7 access, drive-up access, first-floor access, enhanced security, and wide doors.',
						],
					},
				},
			],
		},
		{
			title: 'Storage Units with Electricity Reviews',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews: reviews,
						title: 'Customers Trust SpareFoot to Find Storage Units with Electricity',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Storage With Electricity FAQs',
						hideStorage: true,
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			noPaddingTop: true,
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						contentCards: [
							{
								title: 'Self Storage',
								date: 'October 24, 2025',
								image: ElectricityFeatured1,
								link: 'https://sparefoot.com/blog/storage-units-with-electricity-how-to-find-storage-with-power',
								content:
									'How to Find Storage Units With Electricity',
							},
							{
								title: 'Self Storage',
								date: 'October 22, 2025',
								image: ElectricityFeatured2,
								link: 'https://www.sparefoot.com/blog/what-is-self-storage-2',
								content: 'What Is Self-Storage',
							},
							{
								title: 'Self Storage',
								date: 'August 07, 2025',
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
								image: ElectricityFeatured3,
								content:
									'How to Pick the Right Size Self-Storage Unit',
							},
							{
								title: 'Self Storage',
								date: 'April 28, 2024',
								link: 'https://www.sparefoot.com/blog/the-top-10-things-you-cant-put-into-self-storage',
								image: ElectricityFeatured4,
								content:
									'What Not to Store: Items You Can’t Put in a Self-Storage Unit',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'ClimateControl',
							'24Hour',
							'DriveUp',
							'Car',
							'Business',
							'RV',
							'Wine',
							'Motorcycle',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
